module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('modal', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    attrs: {
      "item": _vm.about
    },
    on: {
      "hide": function($event) {
        _vm.show = false
      }
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('nav', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visible),
      expression: "visible"
    }],
    staticClass: "site-navigation"
  }, [_c('ul', [_c('li', [_c('div', {
    on: {
      "click": _vm.scrollToTop
    }
  }, [_c('div', {
    staticClass: "link"
  }, [_c('i', {
    staticClass: "icon icon--arrow-top"
  }), _vm._v(" "), _c('div', [_c('span', [_vm._v("Nach")]), _vm._v(" oben")])])])]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.showModal(_vm.index)
      }
    }
  }, [_c('div', {
    staticClass: "link"
  }, [_c('i', {
    staticClass: "icon icon--circle"
  }), _vm._v(" "), _c('div', [_c('span', [_vm._v("Über")]), _vm._v(" mich")])])]), _vm._v(" "), _c('li', [_c('jump', {
    attrs: {
      "target": ".instagram"
    }
  }, [_c('div', {
    staticClass: "link"
  }, [_c('i', {
    staticClass: "icon icon--hash"
  }), _vm._v(" "), _c('div', [_c('span', [_vm._v("Dein")]), _vm._v(" "), _c('span', [_vm._v("Lieb")]), _vm._v(" ding")])])])], 1)])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6176d1dc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Navigation.vue
// module id = 316
// module chunks = 0